<template>
	<div id="app">
		<!-- <div id="nav" v-if="isLoggedIn">
			<router-link to="/">Home</router-link> |
			<router-link to="/about">About</router-link
			><span v-if="isLoggedIn"> | <a @click="logout">Logout</a></span>
		</div> -->
		<router-view />
	</div>
</template>
<script>
//import NotfoundUrl from "./components/dashboard/NotFoundUrl";
export default {
	data() {
		return {};
	},
	computed: {
		isLoggedIn: function() {
			return this.$store.getters.isLoggedIn;
		},
	},
	methods: {
		logout: function() {
			this.$store.dispatch("logout").then(() => {
				this.$router.push("/login");
			});
		},
	},
	created: function() {
		this.$http.interceptors.response.use(undefined, function(err) {
			return new Promise(function() {
				if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
					this.$store.dispatch("logout");
				}
				throw err;
			});
		});
	},
};
</script>

<style scoped></style>
